<template>
<v-layout justify-center>
  <v-flex xs12>
    <v-progress-linear v-if="!isReady" class="ma-0" indeterminate color="blue"></v-progress-linear>
    <v-card v-else flat color="transparent">
      <v-container fluid grid-list-md pa-0>
        <v-layout row wrap>
          <v-flex v-for="item in getItems" :key="item.id" xs12 sm6 lg3>
            <Poster :item="item" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
import Poster from './poster'
export default {
  name: 'userFlight',
  props: [],
  components: {
    Poster
  },
  data () {
    return {
      config: {
        status: {
          ready: false,
          active: false,
          loading: false
        }
      },
      store: {
        items: []
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.get()
    },
    get: function () {
      this.$set(this.config.status, 'loading', true)
      this.axios.post(this.$url.api + 'user/flight/get/items', {
      }, {
        headers: {
          'user-token': this.$localStorage.get('jwt')
        }
      }).then(res => {
        console.log(res)
        this.$set(this.config.status, 'ready', true)
        this.$set(this.config.status, 'loading', false)
        if (res.data && res.data.success) {
          this.$set(this.store, 'items', res.data.data)
        }
      })
    }
  },
  computed: {
    isReady () {
      return this.config.status.ready
    },
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    getItems () {
      return this.store.items || []
    }
  }
}
</script>
<style lang=“scss”>
</style>